import { Directive, ElementRef, HostListener, Input } from "@angular/core";
import { NgModel, FormControl, NgForm, NgControl, ControlValueAccessor } from '@angular/forms';
import { isNullOrUndefined } from './objectUtils';

@Directive({
    selector: "input[numeric]",
    standalone: false
})
export class NumericDirective {

  private valueAccessor: NumericValueAccessor;

  private el: HTMLInputElement;
  public parametersObject: NumericDirectiveParameters;
  //Variavel para controlo da alteração dos parametros
  private _parameters: string;

  @Input()
  public set numeric(value: string) {
    if (this._parameters !== value) {

      this._parameters = value;

      if (this._parameters && this._parameters.trim()) {
        const places = this._parameters.replace(/-/g, '').split(/\.|,/);

        this._parameters.trim();
        this.parametersObject.hasSign = this._parameters.charAt(0) === '-';
        this.parametersObject.decimalPlaces = places[1] ? parseInt(places[1]) : 0;
        this.parametersObject.integerPlaces = parseInt(places[0]);// - this.decimalPlaces;
      }
      else {
        this.parametersObject.integerPlaces = this.parametersObject.integerPlaces;// - this.decimalPlaces;
      }

      this.parametersObject.regexRule = (this.parametersObject.decimalPlaces > 0 ? this.parametersObject.decimalTemplate : this.parametersObject.integerTemplate)
        .replace(/_s_/g, this.parametersObject.hasSign ? "-?" : "")
        .replace(/_i_/g, this.parametersObject.integerPlaces.toString())
        .replace(/_d_/g, this.parametersObject.decimalPlaces.toString());
    }

  }
  public get numeric(): string {
    return this._parameters;
  }


  constructor(protected elementRef: ElementRef, private ngModel: NgModel, private ngControl: NgControl
  ) {
    this.parametersObject = new NumericDirectiveParameters();
    this.el = this.elementRef?.nativeElement;
    if (ngControl === undefined)
      return;

    this.ngControl.valueAccessor = this.valueAccessor = new NumericValueAccessor(this.ngControl.valueAccessor, this,this.el);
  }

  public checkRegex(newValue: any, parameters: NumericDirectiveParameters) {
    if (isNullOrUndefined(newValue))
      this.parametersObject.currentValue = "";
    else {
      if (this.parametersObject.decimalPlaces > 0 && newValue.toString().indexOf(",") > -1) {
        newValue = newValue.toString().replace(",",".")
      }
      
      if (RegExp(this.parametersObject.regexRule).test(newValue)) {
        if (this.parametersObject.decimalPlaces > 0 && newValue.toString().indexOf(".") > -1) {
          newValue = newValue.toString().replace(".", ",")
        }
        this.parametersObject.currentValue = newValue;
      }
    }

    if (newValue !== this.parametersObject.currentValue) {
      const selStart = this.el.selectionStart;
      const selEnd = this.el.selectionEnd;
      const selDir = this.el.selectionDirection as "forward" | "backward" | "none";

      //this.el.value = this.parametersObject.currentValue;
    }
    return this.parametersObject.currentValue;
  }

  @HostListener("focus", ["$event.target.value"])
  onFocus(value) {
    this.parametersObject.currentValue = value;
  }

  public updateCurrentValue(): void {
    this.parametersObject.currentValue = this.el.value;
  }
}

class NumericDirectiveParameters {
  public decimalTemplate: string = "^_s_((((\\.)\\d{1,_d_})|(\\d{0,_i_}(\\.)\\d{1,_d_})|(\\d{0,_i_}(\\.))|(\\d{0,_i_})))$";
  public integerTemplate: string = "^_s_(\\d{0,_i_})$";
  public regexRule: string = "";
  public integerPlaces: number = 6;
  public decimalPlaces: number = 2;
  public hasSign: boolean = false;
  public currentValue = "";
}


class NumericValueAccessor implements ControlValueAccessor {

  private el: HTMLInputElement;
  private propagateChange = (_: unknown) => { };

  private onControlChange = (value: unknown) => {
    const translatedValue = this.directive.checkRegex(value, this.directive.parametersObject)
    this.el.value  = translatedValue;
    this.propagateChange(translatedValue);
  }

  constructor(private innerAccessor: ControlValueAccessor, private directive: NumericDirective, protected elementRef: HTMLInputElement) {
    this.innerAccessor.registerOnChange(this.onControlChange);
    this.el = elementRef;
  }

  writeValue(obj: unknown): void {
    this.innerAccessor.writeValue(obj);
  }
  registerOnChange(fn: unknown): void {
    this.propagateChange = fn as any;
  }
  registerOnTouched(fn: unknown): void {
    this.innerAccessor.registerOnTouched(fn);
  }
  setDisabledState?(isDisabled: boolean): void {
    this.innerAccessor.setDisabledState(isDisabled);
  }
}
